module.exports = __webpack_public_path__ + "static/media/Farlig.0c00d605.mp3";